import { ApiFetch } from '../../../shared/utils/fetch';
import { unwrap, type Enveloped } from '../../../shared/utils/unwrap';
import type { Settlement } from '../types';

export const settlementsApi = {
  listByMerchant: async (tenantId: string): Promise<Settlement[]> => {
    const response = await ApiFetch.get<Enveloped<Settlement[]>>(`/settlements/merchant/${tenantId}`);
    return unwrap(response);
  },
};
